'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropTypes = require('../../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _jssThemeReactor = require('jss-theme-reactor');

var _reactSortableHoc = require('react-sortable-hoc');

var _SortableContainer = require('./SortableContainer');

var _SortableContainer2 = _interopRequireDefault(_SortableContainer);

var _context = require('../../util/context');

var _context2 = _interopRequireDefault(_context);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PRESS_DELAY = 300;

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('SortableList', function (theme) {
  return {
    '@global': {
      '*': {
        '-webkit-tap-highlight-color': 'rgba(0,0,0,0)'
      }
    },
    sortableHelper: {
      backgroundColor: theme.palette.text.lightDivider,
      pointerEvents: 'auto !important',
      zIndex: theme.zIndex.sortableHelper,
      '&, & .cursorGrabbing': {
        cursor: 'grabbing',
        fallbacks: {
          cursor: 'move'
        }
      }
    }
  };
});

var SortableList = (_temp2 = _class = function (_PureComponent) {
  _inherits(SortableList, _PureComponent);

  function SortableList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SortableList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SortableList.__proto__ || Object.getPrototypeOf(SortableList)).call.apply(_ref, [this].concat(args))), _this), _this.initState = function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          children = _ref2.children;

      return function (state // eslint-disable-line no-unused-vars
      ) {
        return {
          items: children,
          userIsTouching: false
        };
      };
    }, _this.state = _this.initState(_this.props)(), _this.onFirstTouch = function () {
      return _this.setState({ userIsTouching: true }, function () {
        return _context2['default'].removeEventListener('touchstart', _this.onFirstTouch, false);
      });
    }, _this.onSortEnd = function (_ref3) {
      var oldIndex = _ref3.oldIndex,
          newIndex = _ref3.newIndex;

      _this.setState({
        items: (0, _reactSortableHoc.arrayMove)(_this.state.items, oldIndex, newIndex)
      }, function () {
        return _this.props.onSort(_this.state.items);
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SortableList, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        _context2['default'].addEventListener('touchstart', this.onFirstTouch, false);
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(nextProps) {
        if (nextProps.children === this.props.children) return;
        this.setState(this.initState(nextProps));
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        _context2['default'].removeEventListener('touchstart', this.onFirstTouch, false);
      }

      return componentWillUnmount;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            children = _props.children,
            component = _props.component,
            onSort = _props.onSort,
            other = _objectWithoutProperties(_props, ['children', 'component', 'onSort']);

        var _state = this.state,
            items = _state.items,
            userIsTouching = _state.userIsTouching;

        var classes = this.context.styleManager.render(styleSheet);
        var pressDelay = userIsTouching ? PRESS_DELAY : 0;

        return _react2['default'].createElement(_SortableContainer2['default'], _extends({
          helperClass: classes.sortableHelper,
          onSortEnd: this.onSortEnd
        }, Object.assign({ component: component, items: items, pressDelay: pressDelay }, other)));
      }

      return render;
    }()
  }]);

  return SortableList;
}(_react.PureComponent), _class.propTypes = {
  children: _PropTypes2['default'].node,
  component: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  getContainer: _PropTypes2['default'].func,
  onSort: _PropTypes2['default'].func
}, _class.defaultProps = {
  component: 'div',
  lockAxis: 'y',
  onSort: function () {
    function onSort() {}

    return onSort;
  }(),

  transitionDuration: 0
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp2);
exports['default'] = SortableList;


SortableList.displayName = 'SortableList';


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/List/makeSortable/SortableList.js
// module id = 1674
// module chunks = 32